import { render, staticRenderFns } from "./CreateNewVersionConfirmationDialog.vue?vue&type=template&id=2e939fe6&scoped=true&"
import script from "./CreateNewVersionConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./CreateNewVersionConfirmationDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewVersionConfirmationDialog.vue?vue&type=style&index=0&id=2e939fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e939fe6",
  null
  
)

export default component.exports